import React from 'react'
import PropTypes from 'prop-types'
import GenericBanner from '../GenericBanner'

const BannerContent = ({
  banners,
  contentFontColor,
  headingFontColor,
  smallHeadingFontColor
}) => {
  return banners
    ? banners.map((banner, index) => (
        <GenericBanner
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          content={banner}
          contentFontColor={contentFontColor || 'text.light'}
          headingFontColor={headingFontColor || 'text.base'}
          smallHeadingFontColor={smallHeadingFontColor || 'text.light'}
        />
      ))
    : null
}

BannerContent.propTypes = {
  banners: PropTypes.array,
  contentFontColor: PropTypes.string,
  headingFontColor: PropTypes.string,
  smallHeadingFontColor: PropTypes.string
}

export default BannerContent
